var _circle, _g, _circle2, _circle3, _circle4, _circle5, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 136,
    viewBox: "0 0 172 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86.0003,
    cy: 58.8421,
    r: 58.8421,
    fill: "#99F6E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1444_142105)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8094 18.1053C75.6192 18.1053 64.8359 24.129 58.2737 33.3621C56.1309 32.8569 53.8963 32.5895 51.5993 32.5895C35.6005 32.5895 22.6309 45.5591 22.6309 61.5579C22.6309 77.5567 35.6005 90.5263 51.5993 90.5263L51.6293 90.5263H124.02C124.02 90.5263 124.02 90.5263 124.02 90.5263C138.019 90.5263 149.368 79.1779 149.368 65.1789C149.368 51.18 138.019 39.8316 124.02 39.8316C123.026 39.8316 122.045 39.8889 121.08 40.0003C115.531 27.1214 102.723 18.1053 87.8094 18.1053Z",
    fill: "#F0FDF9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.6003,
    cy: 61.5579,
    rx: 28.9684,
    ry: 28.9684,
    fill: "url(#paint0_linear_1444_142105)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.8101,
    cy: 54.3158,
    r: 36.2105,
    fill: "url(#paint1_linear_1444_142105)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.021,
    cy: 65.1789,
    rx: 25.3474,
    ry: 25.3474,
    fill: "url(#paint2_linear_1444_142105)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.7634,
    cy: 21.5,
    r: 5.65789,
    fill: "#CCFBEF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3683,
    cy: 123.342,
    r: 7.92105,
    fill: "#CCFBEF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.079,
    cy: 39.6053,
    r: 7.92105,
    fill: "#CCFBEF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.632,
    cy: 9.05263,
    r: 4.52632,
    fill: "#CCFBEF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1444_142105)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.8418,
    y: 70.1579,
    width: 54.3158,
    height: 54.3158,
    rx: 27.1579,
    fill: "#107569",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8018 102.158C94.8018 103.412 94.5549 104.653 94.0751 105.811C93.5953 106.969 92.892 108.021 92.0055 108.907C91.119 109.793 90.0665 110.496 88.9083 110.975C87.7501 111.455 86.5088 111.701 85.2553 111.701V107.664C86.2472 107.674 87.225 107.428 88.0948 106.952C88.9342 106.493 89.6313 105.812 90.1099 104.983C90.5894 104.129 90.8412 103.165 90.8412 102.185C90.8412 101.205 90.5894 100.242 90.1099 99.387C89.6319 98.5593 88.9346 97.8797 88.0948 97.4233C87.2118 96.9586 86.2289 96.7158 85.2311 96.7158C84.2332 96.7158 83.2504 96.9586 82.3673 97.4233C81.5286 97.8776 80.8323 98.5557 80.3561 99.3823C80.0204 99.9615 79.7974 100.599 79.699 101.261C78.2508 100.331 77.0596 99.0522 76.2347 97.5416C75.4099 96.0311 74.9779 94.3374 74.9785 92.6163H85.2553C86.5088 92.6157 87.7501 92.862 88.9083 93.3413C90.0665 93.8205 91.1189 94.5232 92.0054 95.4093C92.892 96.2954 93.5952 97.3475 94.0751 98.5055C94.5549 99.6635 94.8018 100.905 94.8018 102.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7988 94.0837V89.6799H102.138L94.7988 94.0837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8024 87.4774V89.6798H87.4582C86.8741 89.6798 86.314 89.4478 85.9009 89.0347C85.4879 88.6217 85.2559 88.0615 85.2559 87.4774V85.275H92.5971C92.8866 85.2745 93.1734 85.3311 93.441 85.4416C93.7086 85.5521 93.9517 85.7142 94.1566 85.9188C94.3614 86.1234 94.5239 86.3663 94.6347 86.6338C94.7455 86.9012 94.8025 87.1879 94.8024 87.4774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1444_142105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.8153 100.582C86.3568 99.8248 85.8469 99.1698 85.5837 98.8468C85.5484 98.8035 85.4956 98.7784 85.4398 98.7784C85.384 98.7784 85.3312 98.8035 85.2959 98.8468C85.0328 99.17 84.5228 99.8252 84.0643 100.582C83.4734 101.557 83.1738 102.364 83.1738 102.979C83.1738 104.228 84.1903 105.245 85.4398 105.245C86.6892 105.245 87.7057 104.228 87.7057 102.979C87.7058 102.363 87.4062 101.557 86.8153 100.582ZM85.7507 104.41C85.6184 104.444 85.4811 104.461 85.3424 104.461C84.4959 104.461 83.8072 103.821 83.8072 103.035C83.8072 102.845 83.8573 102.623 83.956 102.376C83.9727 102.334 84.0202 102.31 84.0671 102.32C84.1139 102.33 84.1454 102.371 84.1406 102.415C84.1348 102.469 84.1318 102.52 84.1318 102.57C84.1318 103.425 84.8214 104.142 85.7359 104.236C85.7814 104.241 85.8169 104.275 85.8206 104.318C85.8242 104.36 85.7949 104.399 85.7507 104.41Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1444_142105",
    x: -0.00071907,
    y: 18.1053,
    width: 172.001,
    height: 117.684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.52632,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1444_142105"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.05263
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.52632
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1444_142105"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.52632,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1444_142105"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.6316
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5789
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1444_142105",
    result: "effect2_dropShadow_1444_142105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1444_142105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1444_142105",
    x: 49.7892,
    y: 61.1053,
    width: 72.4207,
    height: 72.4211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.52632
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1444_142105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1444_142105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1444_142105",
    x1: 29.3566,
    y1: 42.4181,
    x2: 80.5687,
    y2: 90.5263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99F6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1444_142105",
    x1: 60.0056,
    y1: 30.391,
    x2: 124.021,
    y2: 90.5263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99F6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1444_142105",
    x1: 104.558,
    y1: 48.4316,
    x2: 149.369,
    y2: 90.5263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99F6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1444_142105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.46639,
    height: 6.46641,
    fill: "white",
    transform: "translate(82.2061 98.7784)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataImage);
export default __webpack_public_path__ + "static/media/NoDataImage.e3b79ecc9af8700c3e9a12215fdac848.svg";
export { ForwardRef as ReactComponent };